import React, { useState } from "react";
import { Button, Form } from "semantic-ui-react";
import { BasicModal } from "ceco-modal";
import { Pizza } from "ceicons";
import { useTranslation } from "ceco-polyglot";
import { commitMutation } from "react-relay";
import graphql from "babel-plugin-relay/macro";
import { toast } from "react-toastify";
import environment from "../../../environment";
import { isEmpty } from "lodash";

import "./ingredientModal.scss";

export default function IngredientModal(props) {
  const { trigger, edit = false, ingredient, refetchData } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({});
  // const [file, setFile] = useState();
  // const [fileError, setFileError] = useState();
  const [formErrors, setFormErrors] = useState({});
  const t = useTranslation();

  function handleChange(evt) {
    const { value } = evt.target;
    setFormData({
      ...formData,
      [evt.target.name]: value,
    });
  }
  function editIngredient() {
    return new Promise((resolve, reject) => {
      const variables = {
        ...formData,
      };

      commitMutation(environment, {
        mutation: IngredientModalUpdateMutation,
        variables,
        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
      });
    });
  }
  function createIngredient() {
    return new Promise((resolve, reject) => {
      const variables = {
        ...formData,
      };
      commitMutation(environment, {
        mutation: IngredientModalCreateMutation,
        variables,
        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
      });
    });
  }

  const onSubmit = async () => {
    if (validateForm()) {
      const action = !edit ? createIngredient : editIngredient;
      const msg = !edit
        ? t("message.added_ingredient")
        : t("message.edited_ingredient");
      action()
        .then((a) => {
          toast.success(msg);
          setModalOpen(false);
          refetchData();
        })
        .catch((e) => {
          if (Array.isArray(e)) {
            toast.error(e[0].message);
          } else {
            toast.error(e.errors[0].message);
          }
        });
    }
  };

  const validateForm = () => {
    let errors = {};
    let validate = true;

    if (!formData.name) {
      errors = { ...errors, name: t("form.errorRequired") };
    }
    if (!isEmpty(errors)) {
      validate = false;
    }

    setFormErrors(errors);
    return validate;
  };

  return (
    <BasicModal
      size="tiny"
      className="single-button"
      title={
        <div className="modalTitle">
          <Pizza />
          {!edit
            ? t("modalTitle.createIngredient")
            : t("modalTitle.editIngredient")}
        </div>
      }
      trigger={React.cloneElement(trigger, {
        onClick: (e) => {
          e.preventDefault();
          setModalOpen(true);

          edit ? setFormData({ ...ingredient }) : setFormData({});
        },
      })}
      actions={
        <Button
          type="submit"
          onClick={() => {
            onSubmit();
          }}
          primary
        >
          {t("button.save")}
        </Button>
      }
      open={modalOpen}
      closeOnEscape={modalOpen}
      closeOnDimmerClick={modalOpen}
      onModalClose={() => setModalOpen(false)}
      showCloseButton={true}
    >
      <Form onSubmit={onSubmit}>
        <Form.Input
          name="name"
          error={formErrors && formErrors["name"]}
          value={formData.name || ""}
          label={t("form.name")}
          placeholder={t("form.name")}
          onChange={handleChange}
          required
        />
      </Form>
      <p className="required-modal">{t("form.required")}</p>
    </BasicModal>
  );
}
const IngredientModalUpdateMutation = graphql`
  mutation IngredientModalUpdateMutation($id: ID!, $name: String!) {
    ingredientUpdate(input: { id: $id, name: $name }) {
      ingredient {
        name
      }
    }
  }
`;
const IngredientModalCreateMutation = graphql`
  mutation IngredientModalCreateMutation($name: String!) {
    ingredientCreate(input: { name: $name }) {
      ingredient {
        name
      }
    }
  }
`;
